import type { TabsProps as AntdTabsProps } from "antd";
import { Tabs as AntdTabs } from "antd";

export type TabsProps = AntdTabsProps
export const Tabs = AntdTabs;
